import { createSlice } from '@reduxjs/toolkit';
import { type IManagerFromYandex } from '../../types/IManagersFromYandex';
import { getManagersThunk, getManagerThunk } from './managersFromYandexThunks';

export interface IManagersFromYandexState {
  managersFromYandex: IManagerFromYandex[];
  total: number;
  isLoading: boolean;
  error: string | null;
  selectedManager: IManagerFromYandex | null;
  isLoadingManager: boolean;
  managerError: string | null;
}

const initialState: IManagersFromYandexState = {
  managersFromYandex: [],
  total: 0,
  isLoading: false,
  error: null,
  selectedManager: null,
  isLoadingManager: false,
  managerError: null
};

const managersFromYandexSlice = createSlice({
  name: 'managersFromYandex',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearManagerError: (state) => {
      state.managerError = null;
    },
    resetManagersState: (state) => {
      state.managersFromYandex = [];
      state.total = 0;
      state.isLoading = false;
      state.error = null;
    },
    resetSelectedManager: (state) => {
      state.selectedManager = null;
      state.isLoadingManager = false;
      state.managerError = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getManagersThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getManagersThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.managersFromYandex = action.payload.items;
        state.total = action.payload.meta.total;
        state.error = null;
      })
      .addCase(getManagersThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload === undefined
            ? null
            : (action.payload?.message ??
              'Произошла ошибка при загрузке менеджеров');
      })
      .addCase(getManagerThunk.pending, (state) => {
        state.isLoadingManager = true;
        state.managerError = null;
      })
      .addCase(getManagerThunk.fulfilled, (state, action) => {
        state.isLoadingManager = false;
        state.selectedManager = action.payload;
        state.managerError = null;
      })
      .addCase(getManagerThunk.rejected, (state, action) => {
        state.isLoadingManager = false;
        state.managerError =
          action.payload === undefined
            ? null
            : (action.payload?.message ??
              'Произошла ошибка при загрузке менеджера');
      });
  }
});

export const {
  clearError,
  clearManagerError,
  resetManagersState,
  resetSelectedManager
} = managersFromYandexSlice.actions;
export { getManagersThunk, getManagerThunk };
export default managersFromYandexSlice.reducer;
